export function getIsCalendarGridItemOpenedDirectly({ item, onClickItem }) {
  return Boolean(item.isOpenedDirectly && onClickItem)
}
